const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/externalLink.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const REQUEST_ACTION_TYPES_LOAD_EXTERNAL_LINKS = kisapiActionTypes('PATAPP_LOAD_EXTERNALLINKS');

export function loadExternalLinks() {
    const endpoint = `settings/externalLinks`;
    return createPatapiCall(REQUEST_ACTION_TYPES_LOAD_EXTERNAL_LINKS, endpoint, HttpMethod.GET);
}
